import httpService from '../Api/http.service';
import Utils from 'Shared/Utils';
import { getApiBaseUrl } from 'utils';

const getPmsBaseUrl = () => `${getApiBaseUrl()}/pms`;
const getSyncPmsConfigBaseUrl = () => `${getApiBaseUrl()}/sync/pms-config`;

const findPmsPatientDetails = (group_id, location_id, patient_id) =>
  httpService({
    url:
      getPmsBaseUrl() +
      `/patient/find?group_id=${group_id}&location_id=${location_id}&patient_id=${patient_id}`,
    method: 'get',
  });

const postPmsPatientDetails = (payload) =>
  httpService({
    url: getPmsBaseUrl() + '/patients/patient-treatment-plans-procs',
    method: 'post',
    data: payload,
  });

const getPmsPatientDetails = (group_id, location_id, pms_id, patient_id) => {
  const queryParams = Utils.getQueryString({
    group_id,
    location_id,
    pms_id,
    patient_id,
  });
  let endpoint = `/patient?${queryParams}`;

  return httpService({
    url: getPmsBaseUrl() + endpoint,
    method: 'get',
  });
};

const getPmsPatSubscriptions = (location_id, pms_id, pms_display_id) => {
  const queryStringParams = Utils.getQueryString({
    location_id,
    pms_id,
    pms_display_id,
  });
  let endpoint = `/patients/subscriptions?${queryStringParams}`;

  return httpService({
    url: getPmsBaseUrl() + endpoint,
    method: 'get',
  });
};

const createPmsDetails = (payload) =>
  httpService({
    url: getPmsBaseUrl() + `/patient`,
    method: 'post',
    data: payload,
  });

const linkPmsDetails = (payload) =>
  httpService({
    url: getPmsBaseUrl() + `/patient`,
    method: 'put',
    data: payload,
  });

const unlinkPms = (patientId) =>
  httpService({
    url: getPmsBaseUrl() + `/patients/${patientId}/unlink`,
    method: 'put',
  });

const getVendorsList = () =>
  httpService({
    url: getPmsBaseUrl() + `/vendors`,
    method: 'get',
  });

const getConsentVendorsList = () =>
  httpService({
    url: getPmsBaseUrl() + `/patients/form-vendors`,
    method: 'get',
  });

const validatePms = (payload) =>
  httpService({
    url: getPmsBaseUrl() + `/validate`,
    method: 'put',
    data: payload,
  });

const getAppointmentServices = (locationId, params) =>
  httpService({
    url: getPmsBaseUrl() + `/location/${locationId}/service?${params}`,
    method: 'get',
  });

const getAppointmentSlots = (locationId, params) =>
  httpService({
    url: getPmsBaseUrl() + `/location/${locationId}/slot?${params}`,
    method: 'get',
  });

const confirmAppointment = (patientId, data) =>
  httpService({
    url: getPmsBaseUrl() + `/patient/${patientId}/appointment`,
    method: 'post',
    data,
  });

const getPmsAppointmentDetails = (params) =>
  httpService({
    url: getPmsBaseUrl() + `/patients/appointments?${params}`,
    method: 'get',
  });

const getUpcomingAppointments = (patientId) =>
  httpService({
    url: getPmsBaseUrl() + `/patients/${patientId}/appointments`,
    method: 'get',
  });

const getPMSAppointments = (patientId, payload = {}) => {
  return httpService({
    url: getPmsBaseUrl() + `/patients/${patientId}/appointments`,
    method: 'post',
    data: payload,
  });
};

const syncPlanPackage = (planPackageId, partnerId, level, levelId, extraQuery = {}) => {
  const params = Utils.getQueryString({
    partner_id: partnerId,
    level,
    level_id: levelId,
    ...extraQuery,
  });

  return httpService({
    url:
      getPmsBaseUrl() +
      `/plan-package/${planPackageId}/discount-plans?${params}`,
    method: 'post',
  });
};

const getTreatmentProcedures = (payload) => {
  let endpoint = '/patients/treatment-plans-procs-discount';

  return httpService({
    url: getPmsBaseUrl() + endpoint,
    method: 'put',
    data: payload,
  });
};

const generateSavingsCalculatorPdf = (payload) =>
  httpService({
    url: getPmsBaseUrl() + '/treatment-plan/pdf',
    method: 'post',
    data: payload,
  });

const getVendorSettings = () =>
  httpService({
    url: getSyncPmsConfigBaseUrl() + '/vendors',
    method: 'get',
  });

// payload: { vendor: string, firm_name: string, credentials: { [field]: string } }
const createFirm = (payload) =>
  httpService({
    url: getSyncPmsConfigBaseUrl() + '/ssm',
    method: 'post',
    data: payload,
  });

const getFirmsByVendor = (vendor) =>
  httpService({
    url: getSyncPmsConfigBaseUrl() + `/firms?vendor=${vendor}`,
    method: 'get',
  });

const getLocationsByVendorFirm = (vendor, firmName) => {
  const params = Utils.getQueryString({ vendor, firm_name: firmName });
  return httpService({
    url: getSyncPmsConfigBaseUrl() + `/locations?${params}`,
    method: 'get',
  });
};

const pmsService = {
  findPmsPatientDetails,
  postPmsPatientDetails,
  getPmsPatientDetails,
  getPmsPatSubscriptions,
  createPmsDetails,
  linkPmsDetails,
  getVendorsList,
  getConsentVendorsList,
  validatePms,
  getAppointmentServices,
  getAppointmentSlots,
  confirmAppointment,
  getPmsAppointmentDetails,
  getUpcomingAppointments,
  getPMSAppointments,
  syncPlanPackage,
  unlinkPms,
  getTreatmentProcedures,
  generateSavingsCalculatorPdf,
  getVendorSettings,
  createFirm,
  getFirmsByVendor,
  getLocationsByVendorFirm,
};

export default pmsService;
